<template>
    <div>
        <!--面包屑-->
        <p class="breadcrumb">MANAGE BIN</p>
        <!--上方操作框-->
        <el-row class="row-bg p-10 mt-10 bg-lightgarg">
            <el-col :span="5" class="mr-10">
                <el-select v-model="selectUsertype" placeholder="User Type" @change="getselectlist" class="select-bg-s" no-match-text="No data" no-data-text="No data"  style="width: 100%">
                    <el-option v-for="item in options" :label="item.name" :key="item.id" :value="item.id"></el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-input class="input-setMaxWidth" placeholder="Search anything about users" v-model="message" @keyup.enter.native="handleIconClick">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick"></i>
                </el-input>
            </el-col>

        </el-row>
        <!--用户列表-->
        <el-table :data="users" v-loading="loading" element-loading-text="loading..." empty-text="No data" border style="width: 100%" class="mt-20">
            <el-table-column label="Name">
                <template slot-scope="scope">
                    <span>{{scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="action" label="Actions" width="130" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="restoreUser(scope.row)"><i class="icon ion-refresh"></i></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" @click="RemoveUser(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页符-->
        <div class="text-center mt-20 mb-50">
            <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPage" :page-count="totalPages"
                           @current-change="pageCurrentChange">
            </el-pagination>
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                message: '',//搜索框
                role: 'teacher',//默认查看老师列表
                trashed: 1,//1代表已删除
                selecttripvalue: '',//统一接口要求传递参数，页面没有用到但不可删
                selectUsertype: 'Sa',//select框，默认查看teacher列表
                options: [{
                    id: 0,
                    name: 'Sa'
                }, {
                    id: 1,
                    name: 'Ta'
                }, {
                    id: 2,
                    name: 'Student'
                }],
                //列表信息
                loading: true,
                users: [],
                currentPage: 1,
                size: 15,
                totalPages: 1,
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getusers();
            })

        },
        methods: {
            //输入框搜索用户
            handleIconClick() {
                this.getusers()
            },

            //获取列表通用函数
            getusers(){
                this.loading = true;
                this.$http.get('user?role=' + this.role + '&trashed=' + this.trashed + '&page=' + (this.currentPage - 1) + '&tripId=' + this.selecttripvalue + '&keywords=' + this.message).then(response => {
                    //渲染数据
                    this.users = response.list;
                    this.totalPages = response.totalPages;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    this.$message.error(error.message)
                })
            },

            //选择usertype后获取垃圾箱列表
            getselectlist(ev){
                if (ev == 0) {
                    this.role = 'teacher';
                    this.getusers();
                } else if (ev == 1) {
                    this.role = 'ta';
                    this.getusers();
                } else if (ev == 2) {
                    this.role = 'student';
                    this.getusers();
                }

            },

            //改变当前页函数
            pageCurrentChange(val){
                this.currentPage = val;
                this.getusers();
            },

            //删除用户
            RemoveUser(user){
                this.$confirm('Are you sure you want to permanently remove user: ' + user.displayName + '-' +user.givenName + ' ' + user.familyName, 'Permanently Remove User', {
                    confirmButtonText: 'Yes, permanently remove it',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'el-button--danger',
                    type: 'warning',
                    confirmButtonLoading : false,
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            done();
                        } else {
                            instance.confirmButtonLoading = false;
                            done();
                        }
                    }
                }).then(() => {
                    this.$http.delete('user/' + user.userId).then(response => {
                        this.$message.success('User deleted.');
                        this.getusers();
                    }).catch(error => {
                        this.loading = false;
                        this.$message.error(error.message)
                    })
                }).catch(() => {//弹窗点击cancel后执行的方法

                });
            },

            //恢复用户
            restoreUser(user){
                this.$http.patch('user/restore/' + user.userId).then(response => {
                    this.getusers()
                    this.$message.success('Restore user success');
                }).catch(error => {
                    this.loading = false
                    this.Trashdialog = false
                    this.$message.error(error.message)
                })
            },

        }
    }
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// Trash.vue?e7fa513a